import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { ServicesService } from '../../services/services.service';
import { ChatDiscussion } from './models/chat-discussion';

@Injectable()
export class ChatService {
  constructor(private readonly http: ServicesService) {
  }

  apiUrl = environment.apiUrl;

  public fetchDiscussion(maintenanceRequestId: number): Observable<ChatDiscussion> {

    const data = {
      maintenance_request_id: maintenanceRequestId
    };

    return this.http.postRequest<ChatDiscussion>(data, 'fetch-discussion')
      .pipe(
        map(result => {
          const discussion = plainToClass(ChatDiscussion, result);
          discussion.maintenanceRequestId = maintenanceRequestId;
          return discussion;
        })
      );
  }

  public createChatMessage(maintenanceRequestId: number, text: string): Observable<any> {

    const data = {
      maintenance_request_id: maintenanceRequestId,
      text
    };

    return this.http.postRequest(data, 'create-chat-message');
  }

  public markAsRead(maintenanceRequestId: number): Observable<any> {
    const data = {
      maintenance_request_id: maintenanceRequestId
    };

    return this.http.postRequest(data, 'mark-discussion-as-read');
  }
}
